import { Class } from "core/Abacus.Utilities";

const AJAXSaveBookmarkOptions = {};

class AJAXSaveBookmark extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(AJAXSaveBookmarkOptions, options);
    this.setUpEvents();
  }

  setUpEvents() {
    var self = this;
    $("body").on("click", "[data-ajax-save-article]", function(evt) {
      evt.preventDefault();
      self.url = $(this).attr("data-ajax-save-article");
      self.saveArticle(this);
    });
  }

  saveArticle(element) {
    var it = element;
    $.ajax({
      url: this.url,
      success: (html, status) => {
        if ($(html).hasClass("saveStory")) {
          $(it).replaceWith(html);
        }
      },
      error: () => {
        console.log(`Couldn't make request to ${this.url}. Please check URL`);
      }
    });
  }
}

export { AJAXSaveBookmark };



// WEBPACK FOOTER //
// ./Javascript/core/classes/savebookmark/ajax.savebookmark.class.js